<template>
    <div class="billeterie">
        <img src="../assets/img/home/bg-home.svg" class="billeterie--bg bg-black" alt="" />

        <div class="container-lg d-flex flex-column">
            <div class="d-flex justify-content-between align-items-center my-3">
                <img src="../assets/img/home/logo-ref21.svg" class="billeterie--logo" alt="" />
                <h1 class="billeterie--title my-2">Billetterie</h1>
                <img src="../assets/img/home/logo-medef.svg" class="billeterie--logo" alt="" />
            </div>

            <div>
                <div class="d-flex-center py-1 py-sm-3">
                    <button
                        type="button"
                        class="btn btn-lg mx-3 toggle"
                        v-bind:class="[!isTarifEtudiant ? 'btn-primary' : 'btn-outline-primary']"
                        @click="isTarifEtudiant = !isTarifEtudiant"
                        for="chk_yes"
                    >
                        Tarif normal
                    </button>
                    <button
                        type="button"
                        class="btn btn-lg toggle"
                        v-bind:class="[isTarifEtudiant ? 'btn-primary' : 'btn-outline-primary']"
                        @click="isTarifEtudiant = !isTarifEtudiant"
                        for="chk_no"
                    >
                        Tarif étudiant
                    </button>
                </div>
            </div>

            <div class="tarif-normal" v-bind:class="[isTarifEtudiant ? 'd-none' : 'd-block']">
                <!-- <div class="tarif-normal" v-if="!isTarifEtudiant"> -->
                <a
                    title="Logiciel billetterie en ligne"
                    href="https://weezevent.com/?c=sys_widget"
                    class="weezevent-widget-integration"
                    data-src="https://widget.weezevent.com/ticket/E991767/?code=55744&locale=fr-FR&width_auto=1&color_primary=00AEEF"
                    data-width="650"
                    data-height="600"
                    data-id="991767"
                    data-resize="1"
                    data-width_auto="1"
                    data-noscroll="0"
                    data-use-container="yes"
                    data-type="neo"
                    target="_blank"
                    >Billetterie Weezevent Normal</a
                >
            </div>
            <!-- <div class="tarif-etudiant" v-if="isTarifEtudiant"> -->
            <div class="tarif-etudiant" v-bind:class="[isTarifEtudiant ? 'd-block' : 'd-none']">
                <a
                    title="Logiciel billetterie en ligne"
                    href="https://weezevent.com/?c=sys_widget"
                    class="weezevent-widget-integration"
                    data-src="https://widget.weezevent.com/ticket/E997672/?code=21197&locale=fr-FR&width_auto=1&color_primary=00AEEF"
                    data-width="650"
                    data-height="600"
                    data-id="997672"
                    data-resize="1"
                    data-width_auto="1"
                    data-noscroll="0"
                    data-use-container="yes"
                    data-type="neo"
                    target="_blank"
                    >Billetterie Weezevent Etudiant</a
                >
            </div>
            <router-link to="/" class="btn btn-primary mb-5 fs-4 text-uppercase order-last align-self-center">Retour à l'accueil</router-link>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isTarifEtudiant: false,
        };
    },
};
</script>
